import React from "react";
import { MdOutlineDangerous } from "react-icons/md";
import { useDeleteBacklogMutation } from "../Features/projects/projectsApi";

const DeleteBacklogModal = ({ deleteControl, deletationId }) => {
    const [deleteBacklog] = useDeleteBacklogMutation();
    const deleteHandler = () => {
        deleteBacklog(deletationId);
        deleteControl();
    };
    return (
        <>
            <div
                className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                onClick={() => deleteControl()}
            ></div>
            <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                <div className="flex flex-col items-center">
                    <MdOutlineDangerous className="text-red-500 text-7xl" />
                    <h1 className="text-3xl my-2">Are you sure?</h1>
                    <p className="text-center">
                        Do you really want to delete these records? This process
                        cannot be undone
                    </p>
                    <div className="flex justify-center my-5">
                        <button
                            className="text-white px-6 py-2 bg-gray-400 mx-2"
                            onClick={deleteControl}
                        >
                            Cancel
                        </button>
                        <button
                            className="text-white px-6 py-2 bg-red-500 mx-2"
                            onClick={deleteHandler}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeleteBacklogModal;
